































import Vue from "vue";
import { proxyModel } from "@/common/utils/proxyModel";
import { RoleEditForm } from "../forms/RoleEditForm";
import { Permission } from "../../permission/models/Permission";

export default Vue.extend({
  props: {
    value: {
      type: Object as () => RoleEditForm
    },
    permissions: {
      type: Array
    },
    validations: {
      type: Object
    }
  },
  computed: {
    ...proxyModel("name", "selectedPermissions"),
    nameError() {
      return (this as any).validations.name.$error
        ? "ชื่อ Role is required"
        : "";
    },
    permissionError() {
      return (this as any).validations.selectedPermissions.$error
        ? "Permission is required or invalid"
        : "";
    }
  }
});
